module.exports = __webpack_public_path__ + "static/img/order_list.0c1843f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/order_list.png
// module id = LMsW
// module chunks = 8